import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import FencePostCalculator from '@/pages/FencePostCalculator'
import BlockWallCalculator from '@/pages/BlockWallCalculator'
import SonotubeCalculator from '@/pages/SonotubeCalculator'
import ConcreteStepsCalculator from '@/pages/ConcreteStepsCalculator'
import ConcreteWeightCalculator from '@/pages/ConcreteWeightCalculator'
import BagVolumeGuide from '@/pages/BagVolumeGuide'
import ConcreteSlabCost from '@/pages/ConcreteSlabCost'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/fence-post-calculator/', element: <FencePostCalculator /> },
  { path: '/block-wall-calculator/', element: <BlockWallCalculator /> },
  { path: '/sonotube-calculator/', element: <SonotubeCalculator /> },
  { path: '/concrete-steps-calculator/', element: <ConcreteStepsCalculator /> },
  { path: '/concrete-weight-calculator/', element: <ConcreteWeightCalculator /> },
  { path: '/bag-volume-guide/', element: <BagVolumeGuide /> },
  { path: '/concrete-slab-cost/', element: <ConcreteSlabCost /> },
]

function App() {
  return useRoutes(routes)
}

export default App
